/*
  inserted <script src="//www.vitaravinne.fi/cdn/shop/t/8/assets/ccustomJs.js?v=38380911218473993831789367724" defer="defer"></script>
  just </head> in theme.liquid
*/







import { headerMenuHover } from "./ccustomHeaderMenuHoverJs.js?v=14364868429332831011769080373";
import { addItem } from "./ccustomAddItemJs.js?v=135627610678031570361769080367";
import { cartProgressBar } from "./ccustomCartProgressBarJs.js?v=144318528916891956911769080368";
import { updateCart } from "./ccustomUpdateCartJs.js?v=183353268845345840911769080376";
import { updateCartPage } from "./ccustomUpdateCartPageJs.js?v=79428892339127727961769080377";


(function () {
  
  window.customShopify = {};
  customShopify.convertToPriceStr = (num) => {
    return (num/100).toFixed(2).toString().replace('.',',');
  }
  
  //customShopify.addItem = () => document.querySelector("#CartDrawer-Checkout").addEventListener('mousedown', addItem, {once: true});
  customShopify.cartProgressBar = cartProgressBar;
  customShopify.updateCartPage = updateCartPage;
  customShopify.updateCart = updateCart;
  customShopify.addItem = addItem;
  
  headerMenuHover();
  
  //document.querySelector("#CartDrawer-Checkout").addEventListener('submit', addItem, {bubbles: true});
  
})();